import VehicleOffering from '@carvana/merch-contracts/VehicleOffering';
import { LocationSource } from '@carvana/merch-geolocation';
import { useContext, useMemo, useRef } from 'react';
import UserContext, { useUserLocation } from '~/context/common/UserContext';
import {
  DeliveryApi,
  GeoApi,
  LocationChangeCallback,
  LocationData
} from '~/contracts/common/Geolocation';
import fetchSearchDelivery from '~/services/common/fetchSearchDelivery';
import getGeolocationApi from '~/services/common/getGeoLocationApi';

type GeoConfig = {
  geoApi: GeoApi;
  fetchDelivery: DeliveryApi;
  onCloseHandler: () => void;
  onUserLocationChange?: LocationChangeCallback;
};

type OwnArgs = {
  offeringType?: VehicleOffering;
  onSuccessfulZipChange?: () => void;
  onZipChange?: (zip: string) => void;
  setGeolocationModalOpen: (open: boolean) => void;
};

export default function useGeoLocationConfig({
  offeringType,
  onSuccessfulZipChange,
  onZipChange,
  setGeolocationModalOpen
}: OwnArgs): GeoConfig {
  const {
    location: { setData: setLocation }
  } = useContext(UserContext);
  const userLocation = useUserLocation();
  const geolocation = useRef<Partial<LocationData>>(userLocation);

  return useMemo<GeoConfig>(
    () => ({
      fetchDelivery: (zipcode: string) =>
        fetchSearchDelivery(zipcode, offeringType),
      geoApi: getGeolocationApi(),
      onCloseHandler() {
        setGeolocationModalOpen(false);
        onSuccessfulZipChange?.();
      },
      onUserLocationChange({ location }) {
        if (geolocation.current.zip === location.zip) return;

        geolocation.current = location;
        setLocation({
          ...location,
          isFromCookies: false,
          source: LocationSource.Modal
        });
        onZipChange?.(location.zip);
      }
    }),
    [
      offeringType,
      onSuccessfulZipChange,
      onZipChange,
      setGeolocationModalOpen,
      setLocation
    ]
  );
}
